export default "__VITE_ASSET__DMtAxwVl__"